import React, { useEffect, Fragment, useState } from 'react';
import axios from 'axios';
import { Formik, FieldArray, Field } from 'formik';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector, useDispatch } from 'react-redux';
import Typography from '@material-ui/core/Typography';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import Grid from '@material-ui/core/Grid';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import Button from '@material-ui/core/Button';
import Select from '@material-ui/core/Select';
import InsertCommentIcon from '@material-ui/icons/InsertComment';
import CrcDialog from '../../../modules/checkListGenerator/crcChecklist/crcChecklistAddRelevancePopUp';
import {
    createGenInfoRequestSave,
    createTravelOutsideRequest,
    panelIndexUpdate,
} from '../../../modules/checkListGenerator/store/actions/index';
import buttonDisable from '../../disableField/buttonDisable';
import { userType } from '../../../config/usertypeValue';
import { CommonConfig } from '../../../config/common-config';
import LoaderPopUp from '../../../components/loaderpopup/loader';

const useStyles = makeStyles((theme) => ({
    margin: {
        margin: theme.spacing(1),
    },
    withoutLabel: {
        marginTop: theme.spacing(3),
    },
    textField: {
        width: '25ch',
    },
    bottomLine: {
        '&:before': {
            borderBottom: '1px solid #ccc !important',
        },
    },
    button: {
        margin: '10px 0px 5px !important',
        width: '155px',
        fontSize: '15px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '6px 10px',
        letterSpacing: 'normal',
        fontFamily: 'Rubik !important',
    },
    checked: {},
    icon: {
        borderRadius: '50%',
        width: 16,
        height: 16,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#f5f8fa',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        '$root.Mui-focusVisible &': {
            outline: '2px auto rgba(19,124,189,.6)',
            outlineOffset: 2,
        },
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },
    checkedIcon: {
        backgroundColor: '#137cbd',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: '#106ba3',
        },
    },
    inlineDisplay: {
        listStyle: 'none',
        padding: '0',
        '& li': {
            display: 'inline-block',
            padding: '0px 10px 0px 0px',
            color: '#7779ba',
        },
        '& label': {
            marginLeft: '0',
        },
    },
    expenditure: {
        listStyle: 'none',
        padding: '0',
        '& li': {
            padding: '10px 0',
            color: '#7779ba',
        },
        '& label': {
            marginLeft: '0',
        },
    },
    relevanceIndicator: {
        color: '#f9f9f9',
        backgroundColor: '#3ccbcb',
        paddingTop: '5px',
        paddingRight: '40px',
        paddingBottom: '5px',
        paddingLeft: '40px',
        fontFamily: 'Rubik',
    },

    irrelevanceIndicator: {
        color: '#f9f9f9',
        backgroundColor: '#db466b',
        paddingTop: '5px',
        paddingRight: '40px',
        paddingBottom: '5px',
        paddingLeft: '40px',
        fontFamily: 'Rubik',
    },

    partrelevanceIndicator: {
        color: '#f9f9f9',
        backgroundColor: ' #FFC300',
        paddingTop: '5px',
        paddingRight: '40px',
        paddingBottom: '5px',
        paddingLeft: '40px',
        fontFamily: 'Rubik',
    },
    fntRubik: {
        fontFamily: 'Rubik !important',
    },
}));
function StyledRadio(props) {
    const classes = useStyles();

    return (
        <Radio
            className={classes.root}
            disableRipple
            color="default"
            checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
            icon={<span className={classes.icon} />}
            {...props}
        />
    );
}

export default function CrcTravelledOutsideIndia(props) {
    let temptraveloutside = {};
    const classes = useStyles();
    const [itecOpen, setItecOpen] = React.useState(false);
    const dispatch = useDispatch({});
    const [relevanceCat, setRelevanceCat] = React.useState('');
    const [panel, setPanel] = React.useState('');
    const [relevenceDispay, setRelevenceDispay] = useState('');
    const [category, setCategory] = React.useState('');
    const [remarks, setRemarks] = React.useState('');
    const [relevanceindex, setRelevanceIndex] = useState(0);
    const [apiResponse, setApiResponse] = React.useState('');
    const [apiResponseBank, setApiResponseBank] = React.useState('');
    const [apithirdscreenvalues, setApithirdscreenvalues] = React.useState('');
    const [apigeneralinfo, setApigeneralinfo] = React.useState('');
    const [apiincomeTaxValues, setApiincomeTaxValues] = React.useState('');
    const [apidirectorCompany, setApidirectorCompany] = React.useState('');
    const [apiassetHome, setApiassetHome] = React.useState('');
    const [apiassetNature, setApiassetNature] = React.useState('');
    const [apiclient1, setApiclient1] = React.useState('');
    const [apiclient2, setApiclient2] = React.useState('');
    const [apiclient3, setApiclient3] = React.useState('');
    const [apiclient4, setApiclient4] = React.useState('');
    const [apiclient5, setApiclient5] = React.useState('');
    const [apiclient6, setApiclient6] = React.useState('');
    const [apiclient7, setApiclient7] = React.useState('');
    const [apiclient8, setApiclient8] = React.useState('');
    const [apiclient9, setApiclient9] = React.useState('');
    const [apiclient10, setApiclient10] = React.useState('');
    const [apilabelAdata, setApilabelAdata] = React.useState('');
    const [apilabelBdata, setApilabelBdata] = React.useState('');
    const [apilabelCdata, setApilabelCdata] = React.useState('');
    const [apilabelDdata, setApilabelDdata] = React.useState('');
    const [apilabelEdata, setApilabelEdata] = React.useState('');
    const [apiyesorNoType, setApiyesorNoType] = React.useState('');
    const imcNameSelected = useSelector((state) => state.serviceCheckListReducer.imcNameSelected);
    const [apiAddAdditionalQue, setApiAddAdditionalQue] = React.useState('');
    const userDetails = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails);
    const usertype = userDetails.result && userDetails.result.data.features[5].branchName;
    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;
    const serviceIdValue = useSelector((state) => state.serviceCheckListReducer.serviceIdSelected);
    const stageId = useSelector((state) => state.serviceCheckListReducer.selectedStageId);
    const [yearValue, setYearValue] = React.useState('');
    const tennantname = useSelector((state) => state.loginsuccessreducer.tennantName);
    const tennantnameValue = tennantname && tennantname.tennantName;
    const tennantName = tennantnameValue && tennantnameValue.toUpperCase();
    const checklist1que = apiResponse;
    const [showLoader, setShowLoader] = useState(false);

    const createtraveloutside = useSelector((state) => state.geninforeducer.createtraveloutside);
    if (createtraveloutside.serviceIdValue === serviceIdValue) {
        temptraveloutside = createtraveloutside && createtraveloutside.params;
    }

    const handleRelevence = (name, categoryValue, remarksValue, index) => {
        setCategory(categoryValue);
        setRemarks(remarksValue);
        setRelevanceIndex(index);
        setRelevanceCat(name);
        setTimeout(() => {
            setItecOpen(true);
        }, 1000);
    };
    const handleItecClose = () => {
        setTimeout(() => {
            setItecOpen(false);
        }, 1000);
    };

    const initialValues = {};
    let data = [];

    const traveloutsideType = checklist1que && checklist1que[4].fields[0].response;

    // Screen 5
    let travelOutsideArr = [];
    if (checklist1que && checklist1que[4].subQuestion[0].fields.length > 1) {
        for (let i = 0; i < checklist1que[4].subQuestion[0].fields.length; i += 2) {
            let travelOutsideArrtemp = {
                year: checklist1que[4].subQuestion[0].fields[i].response,
                yearRelevance: checklist1que[4].subQuestion[0].fields[i].relevanceResponseCRC,
                yearRelevanceRemarks: checklist1que[4].subQuestion[0].fields[i].relevanceRemarksCRC,
                daysIndia: checklist1que[4].subQuestion[0].fields[i + 1].response,
                daysIndiaRelevance: checklist1que[4].subQuestion[0].fields[i + 1].relevanceResponseCRC,
                daysIndiaRelevanceRemarks: checklist1que[4].subQuestion[0].fields[i + 1].relevanceRemarksCRC,
            };
            travelOutsideArr.push(travelOutsideArrtemp);
        }
    } else {
        let travelOutsideArrtemp = {
            year: '',
            yearRelevance: '',
            yearRelevanceRemarks: '',
            daysIndia: '',
            daysIndiaRelevance: '',
            daysIndiaRelevanceRemarks: '',
        };
        travelOutsideArr.push(travelOutsideArrtemp);
    }
    initialValues.travelOutside = travelOutsideArr;

    const getFinancialYearList = (dropdownIndex, travelOutSide) => {
        const CurentYear = yearValue;
        const minYear = CurentYear - 10;
        const options = [];
        for (let i = minYear; i <= CurentYear; i++) {
            let isDisabled = false;
            for (let j = 0; j < travelOutSide.length; j++) {
                if (travelOutSide[j].year == i) {
                    isDisabled = true;
                }
            }
            options.push(
                <option key={i} value={i} disabled={isDisabled}>
                    {i}-{i + 1}
                </option>
            );
        }
        return options;
    };

    useEffect(() => {
        if (props.panel) {
            setPanel(props.panel);
        }
        setApiResponse(props.apiResponse);
        setApiResponseBank(props.bankDetails);
        setApithirdscreenvalues(props.thirdscreenvalues);
        setApiincomeTaxValues(props.incomeTaxValues);
        setApigeneralinfo(props.generalinfo);
        setApidirectorCompany(props.directorCompany);
        setApiassetHome(props.assetHome);
        setApiassetNature(props.assetNature);
        setApiclient1(props.client1);
        setApiclient2(props.client2);
        setApiclient3(props.client3);
        setApiclient4(props.client4);
        setApiclient5(props.client5);
        setApiclient6(props.client6);
        setApiclient7(props.client7);
        setApiclient8(props.client8);
        setApiclient9(props.client9);
        setApiclient10(props.client10);
        setApilabelAdata(props.labelAdata);
        setApilabelBdata(props.labelBdata);
        setApilabelCdata(props.labelCdata);
        setApilabelDdata(props.labelDdata);
        setApilabelEdata(props.labelEdata);
        setApiyesorNoType(props.yesorNoType);
        setApiAddAdditionalQue(props.addAdditionalQue);

        let temp;
        axios
            .get(
                `${CommonConfig.dev.baseUrl1}/api/auth/service/${
                    tennantName === 'ADVITH' ? tennantnameValue : imcNameSelected
                }/${serviceIdValue}`,
                {
                    headers: {
                        Authorization: bearerToken,
                    },
                }
            )
            .then((response) => {
                let tempYear = response.data ? response.data.serviceYear : '';
                temp = tempYear.split('-')[0];
                setYearValue(parseInt(temp));
            })
            .catch((error) => {});
    }, [userToken, props]);

    const updateCRCRelevance = (category, remarks, travelOutsideIndex) => {
        // setShowLoader(true);
        setTimeout(() => {
            setItecOpen(false);
        }, 2000);
        const data2 = {
            year: checklist1que[4].subQuestion[0].fields[travelOutsideIndex].response,
            yearRelevance:
                (temptraveloutside.travelOutside && temptraveloutside.travelOutside[travelOutsideIndex].yearRelevance) ||
                checklist1que[4].subQuestion[0].fields[travelOutsideIndex].relevanceResponseCRC,
            yearRelevanceRemarks:
                (temptraveloutside.travelOutside && temptraveloutside.travelOutside[travelOutsideIndex].yearRelevanceRemarks) ||
                checklist1que[4].subQuestion[0].fields[travelOutsideIndex].relevanceRemarksCRC,

            daysIndia: checklist1que[4].subQuestion[0].fields[travelOutsideIndex].response,
            daysIndiaRelevance:
                (temptraveloutside.travelOutside && temptraveloutside.travelOutside[travelOutsideIndex].daysIndiaRelevance) ||
                checklist1que[4].subQuestion[0].fields[travelOutsideIndex].relevanceResponseCRC,
            daysIndiaRelevanceRemarks:
                (temptraveloutside.travelOutside && temptraveloutside.travelOutside[travelOutsideIndex].daysIndiaRelevanceRemarks) ||
                checklist1que[4].subQuestion[0].fields[travelOutsideIndex].relevanceRemarksCRC,
        };

        if (temptraveloutside.travelOutside != undefined) {
            if (temptraveloutside.travelOutside[travelOutsideIndex] != undefined) {
                data = temptraveloutside.travelOutside;
            } else {
                data = temptraveloutside.travelOutside;
                data.push(data2);
            }
        } else {
            for (let i = 0; i < travelOutsideArr.length; i++) {
                let data2 = {
                    year: travelOutsideArr[i].year,
                    yearRelevance: travelOutsideArr[i].yearRelevance,
                    yearRelevanceRemarks: travelOutsideArr[i].yearRelevanceRemarks,

                    daysIndia: travelOutsideArr[i].daysIndia,
                    daysIndiaRelevance: travelOutsideArr[i].daysIndiaRelevance,
                    daysIndiaRelevanceRemarks: travelOutsideArr[i].daysIndiaRelevanceRemarks,
                };
                data.push(data2);
            }
        }
        //data = initialValues.travelOutside;
        if (relevanceCat === 'year') {
            data[travelOutsideIndex].yearRelevance = category;
            data[travelOutsideIndex].yearRelevanceRemarks = remarks;
        }
        if (relevanceCat === 'daysIndia') {
            data[travelOutsideIndex].daysIndiaRelevance = category;
            data[travelOutsideIndex].daysIndiaRelevanceRemarks = remarks;
        }

        let data1 = {
            travelOutside: data,
            bankDetails: apiResponseBank,
            ...apigeneralinfo,
            ...apiincomeTaxValues,
            ...apithirdscreenvalues,
            directorCompany: apidirectorCompany,
            assetHome: apiassetHome,
            assetNature: apiassetNature,
            client1: apiclient1,
            client2: apiclient2,
            client3: apiclient3,
            client4: apiclient4,
            client5: apiclient5,
            client6: apiclient6,
            client7: apiclient7,
            client8: apiclient8,
            client9: apiclient9,
            client10: apiclient10,
            labelAdata: apilabelAdata,
            labelBdata: apilabelBdata,
            labelCdata: apilabelCdata,
            labelDdata: apilabelDdata,
            labelEdata: apilabelEdata,

            incomeTaxType: apiyesorNoType && apiyesorNoType.incomeTaxType,
            traveloutsideType: apiyesorNoType && apiyesorNoType.traveloutsideType,
            directorType: apiyesorNoType && apiyesorNoType.directorType,
            assetradio: apiyesorNoType && apiyesorNoType.assetradio,
            totalincomeradio: apiyesorNoType && apiyesorNoType.totalincomeradio,
            additionalQue: apiAddAdditionalQue,
        };

        // console.log('travelOoutside =>>>>>>> data1', data1);
        setRelevenceDispay(data1);
        dispatch(createTravelOutsideRequest({ params: data1, serviceIdValue: serviceIdValue }));
        dispatch(panelIndexUpdate({ panelID: 'panel5' }));
        dispatch(createGenInfoRequestSave({ params: data1, bearerToken, serviceIdValue: serviceIdValue, usertype, imcNameSelected }));
        props.onChange(data1);
        props.rerenderApi(!props.rerender);
        // setTimeout(() => {
        //     setShowLoader(false);
        // }, 10000);
    };

    return (
        <>
            {showLoader ? <LoaderPopUp showLoader={showLoader} /> : null}

            <Formik initialValues={initialValues} enableReinitialize>
                {(formik) => {
                    return (
                        // <form onSubmit={formik.handleSubmit}>
                        <Grid container spacing={3} className="main-container">
                            <Grid item xs={12} sm={12}>
                                <FormControl component="fieldset" disabled>
                                    <RadioGroup
                                        disabled
                                        defaultValue="Yes"
                                        aria-label="yes-no"
                                        id="traveloutsideType"
                                        name="traveloutsideType"
                                        className="radio-option"
                                        onChange={formik.handleChange}
                                        value={traveloutsideType}
                                    >
                                        <ul className={classes.inlineDisplay}>
                                            <li>
                                                <FormControlLabel
                                                    name="traveloutsideType"
                                                    value="Yes"
                                                    control={<StyledRadio />}
                                                    label="Yes"
                                                />
                                            </li>
                                            <li>
                                                <FormControlLabel
                                                    name="traveloutsideType"
                                                    value="No"
                                                    control={<StyledRadio />}
                                                    label="No"
                                                />
                                            </li>
                                        </ul>
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                            {/* <div style={{ display: yes }}> */}
                            {traveloutsideType === 'Yes' ? (
                                <FieldArray name="travelOutside">
                                    {(fieldArrayProps) => {
                                        const { form } = fieldArrayProps;
                                        const { values } = form;
                                        const { travelOutside } = values;
                                        let key = 0;
                                        return (
                                            <>
                                                {travelOutside.map((travelOutsideItem, travelOutsideIndex) => {
                                                    key++;
                                                    return (
                                                        <Fragment key={key}>
                                                            {travelOutsideIndex > 0 && (
                                                                <div className="field-divider">
                                                                    <hr />
                                                                </div>
                                                            )}
                                                            <Grid item xs={12} sm={12}>
                                                                <Typography variant="subtitle1" gutterBottom className={classes.fntRubik}>
                                                                    Please select each financial year and add the No. of days stayed for the
                                                                    last 11 years including current financial year to determine the
                                                                    residential status.
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item xs={12} sm={6}>
                                                                <FormControl fullWidth className={classes.margin}>
                                                                    <InputLabel htmlFor="select-year" shrink>
                                                                        Select Year
                                                                    </InputLabel>

                                                                    <Field name={`travelOutside[${travelOutsideIndex}].year`}>
                                                                        {(fieldProps) => {
                                                                            const { field, meta } = fieldProps;
                                                                            // const { value, onBlur, name } = field;
                                                                            //console.log(field, 'Field Select Travel Outside');
                                                                            return (
                                                                                <>
                                                                                    <Select
                                                                                        disabled
                                                                                        native
                                                                                        id="travel-year"
                                                                                        className={classes.bottomLine}
                                                                                        // placeholder={formValues.year}
                                                                                        // open={open}
                                                                                        // onClose={handleClose}
                                                                                        // onOpen={handleOpen}
                                                                                        {...field}
                                                                                        // inputProps={{
                                                                                        //     name: 'Select Year',
                                                                                        //     id: 'year',
                                                                                        // }}
                                                                                    >
                                                                                        <option value="">Please Select</option>
                                                                                        {getFinancialYearList(
                                                                                            travelOutsideIndex,
                                                                                            travelOutside
                                                                                        )}
                                                                                        {/* <option value="2020">2020</option>
                                                                                        <option value="2021">2021</option>
                                                                                        <option value="2022">2022</option> */}
                                                                                    </Select>
                                                                                    {meta.touched && meta.error ? (
                                                                                        <span className="itec-validationError">
                                                                                            {meta.error}
                                                                                        </span>
                                                                                    ) : null}
                                                                                </>
                                                                            );
                                                                        }}
                                                                    </Field>

                                                                    <Typography variant="caption" gutterBottom className={classes.fntRubik}>
                                                                        In the above case, year represents April to March in each case
                                                                    </Typography>
                                                                    {travelOutside && travelOutside[travelOutsideIndex] ? (
                                                                        travelOutside[travelOutsideIndex].yearRelevance === 'Relevant' ? (
                                                                            <div className={classes.relevanceIndicator}>
                                                                                {travelOutside[travelOutsideIndex].yearRelevanceRemarks}
                                                                            </div>
                                                                        ) : travelOutside[travelOutsideIndex].yearRelevance ===
                                                                          'Irrelavant' ? (
                                                                            <div className={classes.irrelevanceIndicator}>
                                                                                {travelOutside[travelOutsideIndex].yearRelevanceRemarks}
                                                                            </div>
                                                                        ) : travelOutside[travelOutsideIndex].yearRelevance ===
                                                                          'Paritially Relevant' ? (
                                                                            <div className={classes.partrelevanceIndicator}>
                                                                                {travelOutside[travelOutsideIndex].yearRelevanceRemarks}
                                                                            </div>
                                                                        ) : (
                                                                            ''
                                                                        )
                                                                    ) : (
                                                                        <div>
                                                                            <Typography className={classes.bottomLine}>
                                                                                {relevenceDispay.travelOutside[travelOutsideIndex]
                                                                                    .yearRelevance === 'Relevant' ? (
                                                                                    <div className={classes.relevanceIndicator}>
                                                                                        {
                                                                                            relevenceDispay.travelOutside[
                                                                                                travelOutsideIndex
                                                                                            ].yearRelevanceRemarks
                                                                                        }{' '}
                                                                                    </div>
                                                                                ) : relevenceDispay.travelOutside[travelOutsideIndex]
                                                                                      .yearRelevance === 'Irrelavant' ? (
                                                                                    <div className={classes.irrelevanceIndicator}>
                                                                                        {
                                                                                            relevenceDispay.travelOutside[
                                                                                                travelOutsideIndex
                                                                                            ].yearRelevanceRemarks
                                                                                        }
                                                                                    </div>
                                                                                ) : relevenceDispay.travelOutside[travelOutsideIndex]
                                                                                      .yearRelevance === 'Paritially Relevant' ? (
                                                                                    <div className={classes.partrelevanceIndicator}>
                                                                                        {
                                                                                            relevenceDispay.travelOutside[
                                                                                                travelOutsideIndex
                                                                                            ].yearRelevanceRemarks
                                                                                        }
                                                                                    </div>
                                                                                ) : (
                                                                                    ''
                                                                                )}
                                                                            </Typography>
                                                                        </div>
                                                                    )}
                                                                    {stageId === 10 && usertype === 'EM' ? (
                                                                        ''
                                                                    ) : stageId === 8 &&
                                                                      travelOutside[travelOutsideIndex].yearRelevance === 'Relevant' ? (
                                                                        ''
                                                                    ) : (
                                                                        // {stageId === 10 && usertype === 'EM' ? ('') : (
                                                                        <Button
                                                                            // disabled={usertype === 'EM' ? 'disabled' : ''}
                                                                            variant="outlined"
                                                                            color="primary"
                                                                            size="small"
                                                                            className={classes.button}
                                                                            startIcon={<InsertCommentIcon />}
                                                                            onClick={() =>
                                                                                handleRelevence(
                                                                                    'year',
                                                                                    // relevenceDispay.yearRelevance,
                                                                                    // relevenceDispay.yearRelevanceRemarks,
                                                                                    (relevenceDispay &&
                                                                                        relevenceDispay.travelOutside[travelOutsideIndex]
                                                                                            .yearRelevance) ||
                                                                                        travelOutside[travelOutsideIndex].yearRelevance,
                                                                                    (relevenceDispay &&
                                                                                        relevenceDispay.travelOutside[travelOutsideIndex]
                                                                                            .yearRelevanceRemarks) ||
                                                                                        travelOutside[travelOutsideIndex]
                                                                                            .yearRelevanceRemarks,
                                                                                    travelOutsideIndex
                                                                                )
                                                                            }
                                                                            disabled={buttonDisable(stageId, userType.value)}
                                                                        >
                                                                            Add Relevance
                                                                        </Button>
                                                                    )}
                                                                </FormControl>
                                                            </Grid>
                                                            <Grid item xs={12} sm={6}>
                                                                <FormControl fullWidth className={classes.margin}>
                                                                    <InputLabel htmlFor="No-of-days-india" shrink>
                                                                        No. of days stayed in India
                                                                    </InputLabel>
                                                                    <Field name={`travelOutside[${travelOutsideIndex}].daysIndia`}>
                                                                        {(fieldProps) => {
                                                                            const { field, meta } = fieldProps;
                                                                            // const { touched, errors } = form;
                                                                            return (
                                                                                <>
                                                                                    <Input
                                                                                        disabled
                                                                                        className={classes.bottomLine}
                                                                                        // value={values.name}
                                                                                        // placeholder={formValues.daysIndia}
                                                                                        {...field}
                                                                                    />
                                                                                    {meta.touched && meta.error ? (
                                                                                        <span className="itec-validationError">
                                                                                            {meta.error}
                                                                                        </span>
                                                                                    ) : null}
                                                                                </>
                                                                            );
                                                                        }}
                                                                    </Field>
                                                                    {travelOutside && travelOutside[travelOutsideIndex] ? (
                                                                        travelOutside[travelOutsideIndex].daysIndiaRelevance ===
                                                                        'Relevant' ? (
                                                                            <div className={classes.relevanceIndicator}>
                                                                                {
                                                                                    travelOutside[travelOutsideIndex]
                                                                                        .daysIndiaRelevanceRemarks
                                                                                }
                                                                            </div>
                                                                        ) : travelOutside[travelOutsideIndex].daysIndiaRelevance ===
                                                                          'Irrelavant' ? (
                                                                            <div className={classes.irrelevanceIndicator}>
                                                                                {
                                                                                    travelOutside[travelOutsideIndex]
                                                                                        .daysIndiaRelevanceRemarks
                                                                                }
                                                                            </div>
                                                                        ) : travelOutside[travelOutsideIndex].daysIndiaRelevance ===
                                                                          'Paritially Relevant' ? (
                                                                            <div className={classes.partrelevanceIndicator}>
                                                                                {
                                                                                    travelOutside[travelOutsideIndex]
                                                                                        .daysIndiaRelevanceRemarks
                                                                                }
                                                                            </div>
                                                                        ) : (
                                                                            ''
                                                                        )
                                                                    ) : (
                                                                        <div>
                                                                            <Typography className={classes.bottomLine}>
                                                                                {relevenceDispay.travelOutside[travelOutsideIndex]
                                                                                    .daysIndiaRelevance === 'Relevant' ? (
                                                                                    <div className={classes.relevanceIndicator}>
                                                                                        {
                                                                                            relevenceDispay.travelOutside[
                                                                                                travelOutsideIndex
                                                                                            ].daysIndiaRelevanceRemarks
                                                                                        }{' '}
                                                                                    </div>
                                                                                ) : relevenceDispay.travelOutside[travelOutsideIndex]
                                                                                      .daysIndiaRelevance === 'Irrelavant' ? (
                                                                                    <div className={classes.irrelevanceIndicator}>
                                                                                        {
                                                                                            relevenceDispay.travelOutside[
                                                                                                travelOutsideIndex
                                                                                            ].daysIndiaRelevanceRemarks
                                                                                        }
                                                                                    </div>
                                                                                ) : relevenceDispay.travelOutside[travelOutsideIndex]
                                                                                      .daysIndiaRelevance === 'Paritially Relevant' ? (
                                                                                    <div className={classes.partrelevanceIndicator}>
                                                                                        {
                                                                                            relevenceDispay.travelOutside[
                                                                                                travelOutsideIndex
                                                                                            ].daysIndiaRelevanceRemarks
                                                                                        }
                                                                                    </div>
                                                                                ) : (
                                                                                    ''
                                                                                )}
                                                                            </Typography>
                                                                        </div>
                                                                    )}

                                                                    {stageId === 10 && usertype === 'EM' ? (
                                                                        ''
                                                                    ) : stageId === 8 &&
                                                                      travelOutside[travelOutsideIndex].daysIndiaRelevance ===
                                                                          'Relevant' ? (
                                                                        ''
                                                                    ) : (
                                                                        // {stageId === 10 && usertype === 'EM' ? ('') : (
                                                                        <Button
                                                                            // disabled={usertype === 'EM' ? 'disabled' : ''}
                                                                            variant="outlined"
                                                                            color="primary"
                                                                            size="small"
                                                                            className={classes.button}
                                                                            startIcon={<InsertCommentIcon />}
                                                                            onClick={() =>
                                                                                handleRelevence(
                                                                                    'daysIndia',
                                                                                    // relevenceDispay.daysIndiaRelevance,
                                                                                    // relevenceDispay.daysIndiaRelevanceRemarks,
                                                                                    // relevenceDispay.travelOutside &&
                                                                                    //     relevenceDispay.travelOutside[travelOutsideIndex]
                                                                                    //         .daysIndiaRelevance,
                                                                                    // relevenceDispay.travelOutside &&
                                                                                    //     relevenceDispay.travelOutside[travelOutsideIndex]
                                                                                    //         .daysIndiaRelevanceRemarks,
                                                                                    (relevenceDispay &&
                                                                                        relevenceDispay.travelOutside[travelOutsideIndex]
                                                                                            .daysIndiaRelevance) ||
                                                                                        travelOutside[travelOutsideIndex]
                                                                                            .daysIndiaRelevance,
                                                                                    (relevenceDispay &&
                                                                                        relevenceDispay.travelOutside[travelOutsideIndex]
                                                                                            .daysIndiaRelevanceRemarks) ||
                                                                                        travelOutside[travelOutsideIndex]
                                                                                            .daysIndiaRelevanceRemarks,
                                                                                    travelOutsideIndex
                                                                                )
                                                                            }
                                                                            disabled={buttonDisable(stageId, userType.value)}
                                                                        >
                                                                            Add Relevance
                                                                        </Button>
                                                                    )}
                                                                </FormControl>
                                                            </Grid>
                                                        </Fragment>
                                                    );
                                                })}
                                            </>
                                        );
                                    }}
                                </FieldArray>
                            ) : (
                                ''
                            )}
                            {/* </div> */}
                        </Grid>

                        // </form>
                    );
                }}
            </Formik>
            {itecOpen && (
                <CrcDialog
                    itecOpen={itecOpen}
                    updateCRCRelevance={updateCRCRelevance}
                    handleItecClose={handleItecClose}
                    relevanceindex={relevanceindex}
                    crcCategory={category}
                    crcRemarks={remarks}
                />
            )}
        </>
    );
}
